import { useMemo, useCallback } from "react";
import { useSafeQuery } from "use-safe-query";

import GET_CURRENT_USER_QUERY from "./graphql/getCurrentUserQuery";

/**
 * Hook that exposes the current user logged in.
 */
const useCurrentUser = () => {
  const {
    refetch,
    loading,
    data,
  } = useSafeQuery(GET_CURRENT_USER_QUERY);

  const handleRefetchCurrentUser = useCallback(async () => {
    await refetch?.();
  }, [refetch]);

  const payload = useMemo(() => [
    data?.currentUser,
    loading,
    handleRefetchCurrentUser,
  ], [
    data,
    loading,
    handleRefetchCurrentUser,
  ]);

  return payload;
};

export default useCurrentUser;
